import(/* webpackMode: "eager", webpackExports: ["BusinessView"] */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/sections/ForBusiness/view/business-view.jsx");
